module.exports = __webpack_public_path__ + "img/screen-upload-falha.431c5f27.png";